<template>
  <v-card>
    <v-card-title>
      <v-select
        :items="
          educational_programmes.map(function (t) {
            return { text: t.code, value: t.id };
          })
        "
        v-model="programmes"
        label="programme"
        multiple
        @change="loadStudents()"
      ></v-select>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="students"
      :items-per-page="25"
      class="elevation-1"
      :search="search"
    >
      <template v-slot:item.student_number="{ item }">
        <v-btn text :to="{ name: 'student', params: { id: item.id } }">
          {{ item.student_number }}
        </v-btn>
      </template>
    </v-data-table>
  </v-card>
</template>
<script>
export default {
  name: "Students",

  data: () => ({
    drawer: null,
    headers: [
      { text: "Matricule", value: "student_number" },
      { text: "Prénom", value: "first_name" },
      { text: "Nom", value: "last_name" },
      { text: "Année", value: "year" },
      { text: "INE", value: "ine" },
      { test: "Entité", value: "school" },
    ],
    students: [],
    search: null,
    educational_programmes: [],
    programes: [],
  }),
  methods: {
    loadProgrammes() {
      this.axios
        .get("/programmes")
        .then((response) => (this.educational_programmes = response["data"]));
    },
    loadStudents() {
      this.axios
        .get("/students", {params: {programmes: this.programmes}})
        .then((response) => (this.students = response["data"]));
    },
  },
  mounted() {
    this.loadProgrammes();
    this.loadStudents();
  },
};
</script>